import React, { useMemo, useCallback } from 'react';
import { map, applySpec, prop, pipe, props, filter, join, __, pathOr, hasPath, when, is } from 'ramda';

import { useCurrentSchedule, CANCELLATIONS, DELETE_REASON } from 'store/planning';
import { ID, PUBLIC_ID, LAST_NAME, FIRST_NAME, BIRTH, SUB_PATIENT } from 'store/patients';
import { parseBirthday } from 'utils';
import Accordion from 'components/Accordion';
import Table from 'components/Table';

import { DEFAULT_SORT, TABLE_HEAD, DELETE_REASONS_OBJECT } from './utils';
import Row from './Row';

const UnsubscribeTable = () => {
  const cancellations = useCurrentSchedule(CANCELLATIONS);
  const list = useMemo(
    () =>
      map(
        applySpec({
          id: pipe(prop(SUB_PATIENT), when(is(Object), prop(ID))),
          publicId: ($) => pathOr(prop(PUBLIC_ID, $), [SUB_PATIENT, PUBLIC_ID], $),
          name: pipe(
            when(hasPath([SUB_PATIENT]), prop(SUB_PATIENT)),
            pipe(props([FIRST_NAME, LAST_NAME]), filter(Boolean), join(' '))
          ),
          birth: pipe(($) => pathOr(prop(BIRTH, $), [SUB_PATIENT, BIRTH], $), parseBirthday),
          reason: pipe(prop(DELETE_REASON), prop(__, DELETE_REASONS_OBJECT)),
        })
      )(cancellations || []),
    [cancellations]
  );

  const renderRow = useCallback(($) => <Row {...$} />, []);

  if (!list.length) return null;

  return (
    <Accordion label="Abgesagte Messungen" defaultOpen>
      <Table head={TABLE_HEAD} list={list} renderRow={renderRow} sort={DEFAULT_SORT} />
    </Accordion>
  );
};

export default UnsubscribeTable;
